module.exports = __webpack_public_path__ + "img/cooporative-icon.b6abd4ed.svg";